import axios from 'axios';
import { ElMessage } from 'element-plus';

const requ = axios.create();

requ.interceptors.request.use(config => {
    // 为请求头添加x-access-token字段为服务端返回的token
    const token = localStorage.getItem('user_token');
    config.headers.Authorization = token;
    config.headers.source = "web";
    // return config是固定用法 必须有返回值
    return config
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

let base = '/ai';
export const model_list = () => {
    return requ.get(base + '/bailian/model_list')
        .then(response => response)
};

export function send_vcode(phone) {
    return requ({
        method: 'get',
        url: base + '/anonymous/send_verification_code?phone=' + phone,
    })
}

export function user_login(params) {
    return requ({
        method: 'post',
        url: base + '/login',
        data: params
    })
}

export function user_logout() {
    return requ({
        method: 'post',
        url: base + '/logout'
    })
}

export const user_info = () => {
    return requ.get(base + '/info')
        .then(response => response)
};

export const settle_count = () => {
    return requ.get(base + '/settle_count')
        .then(response => response)
};

export const describe_file = (fileId) => {
    return requ({
        method: 'get',
        url: base + '/file/describe_file?fileId=' + fileId,
    })
}

export const wxlogin_qrcode = () => {
    return requ.get(base + '/anonymous/wechat/qrcode')
        .then(response => response)
};

requ.interceptors.response.use(success => {
    //业务逻辑错误
    if (success.status && success.status == 200) {
        if (success.data.code == 500 || success.data.code == 403) {
            ElMessage.error({message: success.data.message});
            return;
        } else if ( success.data.code == 401){
            //window.localStorage.removeItem("user_token");
            //router.replace("/");
            ElMessage.error({message: success.data.message});
            return;
        } else if (success.data.message) {
            ElMessage.success({message: success.data.message});
        }
    }
    return success.data;
}, error => {
    if (error.response.code == 504 || error.response.code == 404) {
        ElMessage.error({message: '服务器调用错误！'})
    } else if (error.response.code == 403) {
        ElMessage.error({message: '权限不足，请联系管理员！'})
    } else if (error.response.code == 401) {
        ElMessage.error({message: '尚未登录，请登录！'})
        //router.replace('/');
    } else {
        if (error.response.data.message) {
            ElMessage.error({message: error.response.data.message})
        } else {
            ElMessage.error({message: '未知错误！'})
        }
    }
})